<template>
  <img
    v-if="image"
    :src="image"
    alt="Bubble"
    class="bubble_image"
    :class="{ show: visible }"
  />
</template>

<script>
export default {
  props: {
    image: String,
    trigger: Boolean,
  },
  data() {
    return {
      visible: false,
      hasAnimated: false,
    };
  },
  mounted() {
    if (this.trigger === undefined) {
      setTimeout(() => {
        this.visible = true;
      }, 30);
    }
  },
  watch: {
    trigger(val) {
      if (val && !this.hasAnimated) {
        this.hasAnimated = true;

        setTimeout(() => {
          this.visible = true;
        }, 200);
      }
    },
  },
};
</script>

<style>
.bubble_image {
  position: absolute !important;
  top: 0px;
  opacity: 0;
  transform: scale(0.9);
  transition: all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
  will-change: transform, opacity;
  width: 100%;
  height: 100%;
}

.bubble_image.show {
  opacity: 1;
  transform: scale(1);
}
</style>
